import React from 'react';
import ReactDOM from 'react-dom/client';

import styles from './XWindow.module.scss';
//import {DateTime} from "luxon";
import {Position} from "../../Utilities/Utilities";
//import classNames from 'classnames';


export interface IWindowProps {
    children? : React.ReactNode;
    className? : string | undefined;
    dialog: HTMLDialogElement;
    header?: string | undefined;
}

export interface IWindowState {
}

export class XWindow extends React.Component<IWindowProps, IWindowState> {
    isDragging: boolean = false;
    offsetX: number = 0;
    offsetY: number = 0;

    public constructor(props: IWindowProps) {
        super(props);
        this.DoMouseDown = this.DoMouseDown.bind(this);
        this.DoMouseMove = this.DoMouseMove.bind(this);
        this.DoMouseUp = this.DoMouseUp.bind(this);
    }

    private static showInternal(callback: (dialog: HTMLDialogElement) => React.ReactElement<XWindow>): HTMLDialogElement{
        const dialog: HTMLDialogElement = document.createElement("dialog");
        dialog.setAttribute('class', styles.XWindow)
        document.body.appendChild(dialog);
        const rw = ReactDOM.createRoot(dialog);
        const window = callback(dialog);
        rw.render(<>{window}</>);
        return dialog;
    }
    public static showModal(children: (dialog: HTMLDialogElement) => React.ReactElement<XWindow>): HTMLDialogElement{
        const dialog = this.showInternal(children);
        dialog.showModal();
        return dialog;
    }
    public static show(children: (dialog: HTMLDialogElement) =>  React.ReactElement<XWindow>): HTMLDialogElement{
        const dialog = this.showInternal(children);
        dialog.show();
        return dialog;
    }
    public static close(node: HTMLDialogElement) {
        node.close();
        document.body.removeChild(node);
    }
    private DoMouseDown(event: MouseEvent): void {
        if(event.offsetY < 0)
            return;
        if(event.offsetX < 0)
            return;
        if(event.offsetX > this.props.dialog.offsetWidth)
            return;
        const p: Position = this.props.dialog.getOffset();
        const offsetX = event.clientX - this.props.dialog.offsetLeft;
        const offsetY = event.clientY - this.props.dialog.offsetTop;
        const clientY = event.pageY;
        if(clientY - p.top > 28)
            return;
        this.offsetX = offsetX;
        this.offsetY = offsetY;
        this.isDragging = true;

        document.body.style.cursor = 'move';

        document.addEventListener('mousemove', this.DoMouseMove);
        document.addEventListener('mouseup', this.DoMouseUp);
        
    }
    private DoMouseMove(event: MouseEvent): void {
        if (this.isDragging) {
            this.props.dialog.style.left = `${event.clientX - this.offsetX}px`;
            this.props.dialog.style.top = `${event.clientY - this.offsetY}px`;
        }
    }
    private DoMouseUp(event: MouseEvent): void {
        this.isDragging = false;
        document.body.style.cursor = 'default';
        document.removeEventListener('mousemove', this.DoMouseMove);
        document.removeEventListener('mouseup', this.DoMouseUp);
    }

    public render(): React.ReactNode {
        if(this.props.header)
            this.props.dialog.setAttribute('data-header', this.props.header);
        this.props.dialog.onmousedown = this.DoMouseDown;
        return (
            <React.Fragment>
                <div className={styles.XHeader}>{this.props.header}</div>
                {this.props.children}
            </React.Fragment>
        );
    }
}